import type { SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

import baselineSvg from "./min-icon.baseline.svg?react";
import textSvg from "./min-icon.text.svg?react";
import { makeSvgIcon } from "./svg-icon";

const MinIconBaseline = makeSvgIcon(baselineSvg);
const MinIconText = makeSvgIcon(textSvg);

export const MinIcon = forwardRef(function (
  { text = true, ...props }: SvgIconProps & { text?: boolean },
  ref: React.Ref<SVGSVGElement>,
) {
  return text ? (
    <MinIconText {...props} ref={ref} />
  ) : (
    <MinIconBaseline {...props} ref={ref} />
  );
});

export default MinIcon;
